import { useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import * as Sentry from "@sentry/react";

/**
 * Syncs the signed-in Clerk user onto Sentry's scope so any error reports are
 * tagged with the user's ID and primary email. Clears the user on sign-out.
 *
 * Renders nothing — mount once, high in the tree, inside <ClerkProvider>.
 */
export function SentryUserSync(): null {
  const { isLoaded, isSignedIn, user } = useUser();

  useEffect(() => {
    if (!isLoaded) return;

    if (isSignedIn && user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [isLoaded, isSignedIn, user]);

  return null;
}
